export default x => (Array.isArray(x) ? x : [x]);
